import { Grid } from "@mui/material";
import Usuario from "../../../../../models/usuario";
import { map } from "lodash";
import CardCliente from "./cardCliente";

type Props = {
  clientes: Usuario[];
};

export default function GradeClientes({ clientes }: Props) {
  return (
    <Grid container className="clientes">
      {map(clientes, (cliente, index) => (
        <Grid key={index} item xs={12} md={4} p={1}>
          <CardCliente key={index} cliente={cliente} />
        </Grid>
      ))}
    </Grid>
  );
}
